define('plugin/product/view/ProductCategoryEmptyView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Product category empty view
     *
     * @class ProductCategoryEmptyView
     */
    return LayoutView.extend({

        getTemplate: function () {
            return '#product_category_empty_view';
        }

    });

});
